<template>
  <div class="aboutContainer">
    <div class="aboutHeaderContainer">
      <h1>万葉歌碑データベースについて</h1>
      <div class="aboutCloseButton">
        <router-link v-bind:to="`${parentPage}`"
          ><img src="/images/about_close_button.svg" alt="閉じる"
        /></router-link>
      </div>
    </div>
    <div class="aboutBodyContainer">
      <h2>使い方</h2>
      <dl>
        <dt>地図から探す</dt>
        <dd>
          <ul>
            <li>地図上の歌碑アイコンをタップすると詳細パネルが現れます。</li>
            <li>詳細をタップすると解説ページに遷移します。</li>
            <li>
              地図上の色のついた線は古道です。詳しくは、画面右上の凡例を参照してください。
            </li>
          </ul>
        </dd>
        <dt>一覧から探す</dt>
        <dd>
          <ul>
            <li>
              検索ボックスをタップして歌、作者、揮毫者で検索することができます。
            </li>
            <li>
              かんたん検索ワードでは、キーワードをクリックするだけで関連する歌碑を検索できます。
            </li>
          </ul>
        </dd>
      </dl>

      <h2>ご利用にあたってのお願いとお断り</h2>
      <p>
        本データベースは、地域貢献を目的とした万葉歌碑データベースを除いて、すべて学術研究を目的として作成、公開するものです。この点を十分ご理解の上、ご利用下さい。
      </p>
      <ol>
        <li>ご利用は学術研究目的に限ります。</li>
        <li>
          データの改変、再配布及びあらゆる形態の出版物への無断転載は堅くお断りします。掲載を希望される場合は、奈良女子大学古代学学術研究センターの許可をお取りください。
        </li>
        <li>
          著作権等の都合上、一部のデータベースおよびデータは学内利用のみとしています。また、データベース管理の必要から変更や制限を設ける場合があります。
        </li>
      </ol>
      <p>
        その他ご不明な点、お気づきの点などがありましたら、下記までお問い合わせ下さい。
      </p>
      <address>
        連絡先：古代学学術研究センター<br />
        〒630-8506<br />
        奈良市北魚屋東町 奈良女子大学コラボレーションセンター
        <dl>
          <dt>TEL（FAX兼）：</dt>
          <dd><a href="tel:0742203779">0742-20-3779</a></dd>
          <dt>E-mail：</dt>
          <dd>
            <a href="mailto:kodaigaku@cc.nara-wu.ac.jp"
              >kodaigaku@cc.nara-wu.ac.jp</a
            >
          </dd>
        </dl>
      </address>
    </div>
  </div>
</template>

<script lang="ts" src="./AppAbout.ts"></script>
<style scoped lang="scss" src="./AppAbout.scss"></style>
